import { ageRange, guaranteeValue } from "discription";
import dayjs from "dayjs";

export const isDayTravel = (startDate: any, endDate: any) => {
  const dayAfterStartDateString = dayjs(startDate)
    .add(1, "day")
    .format("YYYYMMDD");
  let endDateString = "";
  if (endDate) {
    endDateString = dayjs(endDate).format("YYYYMMDD");
  }
  return dayAfterStartDateString === endDateString;
};

export const isToday = (startDate: any) => {
  const todayString = dayjs().format("YYYYMMDD");
  const startDateString = dayjs(startDate).format("YYYYMMDD");
  return todayString === startDateString;
};

export const validDate = (type: string, date: any) => {
  if (type === "startDate") {
    return dayjs(date).isBefore(dayjs(), "day");
  } else {
    return dayjs(date).isBefore(dayjs().add(1, "day"), "day");
  }
};

export const currentHour = () => {
  return String(dayjs().hour()).length > 1
    ? String(dayjs().hour())
    : `0${String(dayjs().hour())}`;
};

export const setBirthDate = (value: string, sex: string) => {
  if (sex === "3" || sex === "4") {
    return "20" + value;
  } else {
    return "19" + value;
  }
};

export const setSexCode = (value: string, birthday: string) => {
  var birthYear = Number(birthday.substr(0, 4));
  let sexCode;
  if (value === "M") {
    if (birthYear < 2000) {
      sexCode = "1";
    } else {
      sexCode = "3";
    }
  } else {
    if (birthYear < 2000) {
      sexCode = "2";
    } else {
      sexCode = "4";
    }
  }
  return sexCode;
};

export const setUserAge = (birthDay: string) => {
  let currentYear = dayjs().year();
  let currentMonth = dayjs().month() + 1;
  const currentDate = dayjs().date();
  const currentMonthString =
    currentMonth < 10 ? "0" + String(currentMonth) : String(currentMonth);
  const currentDateString =
    currentDate < 10 ? "0" + String(currentDate) : String(currentDate);

  const birthYear = Number(birthDay.substring(0, 4));
  const birthMonth = Number(birthDay.substring(4, 6));
  const birthDate = Number(birthDay.substring(6, 8));

  let diffMonth = 0;
  let age = 0;

  const currentMD = currentMonthString + currentDateString;
  const birthMD = birthDay.substring(4, 6) + birthDay.substring(6, 8);
  const usAge =
    currentMD < birthMD ? currentYear - birthYear - 1 : currentYear - birthYear;
  if (usAge === 14) {
    return usAge;
  } else {
    if (currentDate - birthDate < 0) {
      currentMonth = currentMonth - 1;
    }
    if (currentMonth - birthMonth >= 0) {
      diffMonth = currentMonth - birthMonth;
    } else {
      currentYear = currentYear - 1;
      diffMonth = currentMonth - birthMonth + 12;
    }
    if (diffMonth >= 6) {
      age = currentYear - birthYear + 1;
    } else {
      age = currentYear - birthYear;
    }
    return age;
  }
};
export const setUserPlanPrice = (birthDay: string): any[] => {
  const age = setUserAge(birthDay);
  if (age < 15) {
    return [
      { type: "PL101", price: "" },
      { type: "PL102", price: "" },
      { type: "PL103", price: "" }
    ];
  } else if (age < 71) {
    return [
      { type: "PL104", price: "" },
      { type: "PL105", price: "" },
      { type: "PL106", price: "" }
    ];
  } else if (age < 80) {
    return [
      { type: "PL107", price: "" },
      { type: "PL108", price: "" },
      { type: "PL107", price: "" }
    ];
  } else {
    return [
      { type: "PL109", price: "" },
      { type: "PL109", price: "" },
      { type: "PL109", price: "" }
    ];
  }
};

export const setUserPlan = (birthDay: string): any[] => {
  const age = setUserAge(birthDay);
  if (age < 15) {
    return ["PL101", "PL102", "PL103"];
  } else if (age < 71) {
    return ["PL104", "PL105", "PL106"];
  } else if (age < 80) {
    return ["PL107", "PL108", "PL107"];
  } else {
    return ["PL109", "PL109", "PL109"];
  }
};

export const setScoping = (birthDay: string, planCode: string = ""): any[] => {
  const age = setUserAge(birthDay);
  const planVersion = planCode !== "" ? planCode.split("")[2] : "1";
  if (age < 15) {
    return ageRange[planVersion as keyof typeof ageRange].child;
  } else if (age < 71) {
    return ageRange[planVersion as keyof typeof ageRange].general;
  } else if (age < 80) {
    return ageRange[planVersion as keyof typeof ageRange].senior;
  } else {
    return ageRange[planVersion as keyof typeof ageRange].elder;
  }
};

export const planTypeName = (planCode: string) => {
  if (planCode) {
    return guaranteeValue[planCode as keyof typeof guaranteeValue].name;
  }
};

export const planTypeAmount = (planCode: string, index: number) => {
  if (planCode) {
    return guaranteeValue[planCode as keyof typeof guaranteeValue]
      .specialAmount[index];
  }
};

export const numberWithCommas = (price: string) => {
  if (price) {
    var value = Math.floor(Number(price));
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const numberToDate = (date: Date | undefined) => {
  if (date) {
    return dayjs(date).format("YYYY.MM.DD");
  }
};

export const stringToDate = (date: string | undefined) => {
  if (date) {
    return dayjs(date).format("YYYY.MM.DD");
  }
};

export const numberToTell = (tellNumber: string) => {
  return tellNumber.replace(
    /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
    "$1-$2-$3"
  );
};

export const getVh = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

export const getParameterByName = (name: string, search: string) => {
  if (name && search) {
    //name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  } else {
    return "";
  }
};

export const preventMomentumScroll = (el: any) => {
  const { scrollTop, offsetHeight, scrollHeight } = el;
  if (scrollTop === 0) {
    el.scrollTo(0, 1);
    return true;
  }
  if (scrollTop + offsetHeight >= scrollHeight) {
    el.scrollTo(0, scrollHeight - offsetHeight - 1);
    return true;
  }
  return false;
};

export const toTop = () => window.scrollTo(0, 0);

export const checkParamsMRT = () => {
  if (
    getParameterByName("platform", window.location.search) ===
      "mrt_android_app" ||
    getParameterByName("platform", window.location.search) === "mrt_ios_app"
  ) {
    sessionStorage.setItem(
      "platform",
      getParameterByName("platform", window.location.search)
    );
  }
};

export const getUserId = () => {
  if (getParameterByName("user", window.location.search)) {
    sessionStorage.setItem(
      "mrtInfo",
      getParameterByName("user", window.location.search)
    );
  }
};

export const isNative = () => {
  const platform = sessionStorage.getItem("platform");
  return platform || /traveler/i.test(window.navigator.userAgent);
};

export const MRTException = () => {
  if (isNative()) {
    const platform = sessionStorage.getItem("platform");
    if (platform === "mrt_android_app") {
      if (/traveler/i.test(window.navigator.userAgent)) {
        const possibleVersion = "520";
        const userAgent = window.navigator.userAgent.split(";");
        const userVersionArr = userAgent[userAgent.length - 1].split(".");
        const userVersion = `${userVersionArr[0]}${userVersionArr[1]}${userVersionArr[2]}`;
        if (Number(possibleVersion) - Number(userVersion) > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const externalWeb = (url: string) => {
  if (isNative()) {
    return `mrt://externalweb?url=${encodeURIComponent(url)}`;
  } else {
    return url;
  }
};

export const setAmplitudeText = (step: string, type?: string) => {
  if (type === "simpleCheck") {
    switch (step) {
      case "step1":
        return "plan_check_button";
      case "step2":
        return "register_button";
      default:
        break;
    }
  } else {
    switch (step) {
      case "step1":
        return "next_button";
      case "step2":
        return "price_check_button";
      case "step3":
        return "confirm_button";
      default:
        break;
    }
  }
};

export const mobileWithhyphen = (newValue: string, currentValue: string) => {
  let mobile = newValue.trim().replace(/[^0-9|-]/gi, "");
  let removeHyphon = mobile.replace(/-/gi, "");
  if (newValue.length > currentValue.length) {
    if (mobile.length === 3) {
      mobile = mobile + "-";
    }
    if (mobile.length === 7) {
      mobile = mobile + "-";
    }
  } else {
    if (currentValue.substr(currentValue.length - 1) === "-") {
      mobile = mobile.substr(0, mobile.length - 1);
    }
  }
  if (mobile.length === 13) {
    mobile = removeHyphon.replace(
      /(^01.{1}|[0-9]{3})([0-9]{4})([0-9]{4})/gi,
      "$1-$2-$3"
    );
  }
  if (mobile.length > 13) {
    mobile = mobile.substr(0, 13);
  }
  return mobile;
};
